import React, {Component} from 'react';
import '../../App.css';
// import {TableColumnPopupType} from '../Popup/TableColumnPopup';
// import { getLocalisedText } from '../../Translate/LanguageManager';
// import AppManager from '../../Manager/AppManager';
// import Utility from '../../Utilities/Utility';

import {
    Utility,
    AppManager,
    getLocalisedText,
    TableColumnPopupType
} from 'deskera-doc-builder-lib'
export default class AccountColumnEditor extends Component {

    dataChanged(data) {
        this.props.dataChanged(this.props.data);
    }

    render() {
        return this.getAccountColumns(this.props.columnData)
    }

    getAccountColumns(columnsData = []) {
        var arr = [];
        for (let i = 0; i < columnsData.length; i++) {
            arr.push(this.getAccountColumn(i, columnsData[i]));
        }
        return arr;
    }

    getAccountColumn(index, columnData) {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                }}
            >
                {this.getShowHideValueForTablePopup(TableColumnPopupType.accountName) && this.getColumnTextfields(
                    "account_name",
                    index,
                    columnData.name,
                    this.columnNameChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.description) && this.getColumnTextfields(
                    "description",
                    index,
                    columnData.description,
                    this.columnDescriptionChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.amount) && this.getColumnTextfields(
                    "amount",
                    index,
                    columnData.amount,
                    this.columnAmountChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.tax) && this.getColumnTextfields(
                    getLocalisedText("tax") + " (%)",
                    index,
                    columnData.tax,
                    this.columnAccountTaxChanged,
                )}

                {/* {this.getShowHideValueForTablePopup(TableColumnPopupType.taxAmount) && this.getColumnTextfields(
                    getLocalisedText("tax_amount"),
                    index,
                    columnData.taxAmount,
                    this.columnTaxAmountChanged
                )}

                {this.getShowHideValueForTablePopup(TableColumnPopupType.paymentAmount) && this.getColumnTextfields(
                    getLocalisedText("payment_amount"),
                    index,
                    columnData.paymentAmount,// + (columnData.tax !== "" ? '%' : ""),
                    this.columnPaymentAmountChanged
                )} */}

                <div className='RowDiv'
                    style={{
                        flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
                    }}>
                    <button
                        style={{
                            marginTop: 10,
                            cursor: "pointer",
                            color: "red",
                            border: "solid",
                            borderWidth: 1,
                            borderColor: "rgb(210, 210, 210)",
                            backgroundColor: "white",
                            borderRadius: 4,
                            marginBottom: 20,
                        }}
                        onClick={() => this.deleteColumn(index)}
                    >
                        {getLocalisedText("delete")}
                    </button>
                </div>
            </div>
        );
    }

    deleteColumn(index) {
        var data = this.props.data;
        data["lineItems"].splice(index, 1);
        this.dataChanged(data);
    }

    getColumnTextfields(placeholder, index, value, callback) {
        return (
            <input
                className="TextField"
                style={{
                    marginTop: 6,
                    borderRadius: 4,
                    color: 'rgb(30, 30, 30)'
                }}
                placeholder={getLocalisedText(placeholder)}
                type="text"
                dir={Utility.getInputDirection()}
                value={getLocalisedText(value)}
                onChange={(e) => callback(e, index)}
            />
        );
    }

    columnNameChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["name"] = event.target.value;
        this.dataChanged(data);
    };
    columnDescriptionChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["description"] = event.target.value;
        this.dataChanged(data);
    };

    ///account related
    columnAmountChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["amount"] = value;
        data["lineItems"][index] = this.getTotalAccountAmount(data["lineItems"][index])
        this.dataChanged(data);
    };


    columnAccountTaxChanged = (event, index) => {
        let value = event.target.value
        // let valWithoutPercent = value.replace("%","")
        if (value.length > 3 || isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["tax"] = value;
        data["lineItems"][index] = this.getTotalAccountAmount(data["lineItems"][index])
        this.dataChanged(data);
    };

    getTotalAccountAmount(item) {
        var tax = 0
        var amount = 0
        if(item.tax !== undefined) {
            tax = parseFloat(item.tax)
            if(isNaN(tax)){
                tax = 0
            }
        }
        if(item.amount !== undefined) {
            amount = parseFloat(item.amount)
            if(isNaN(amount)){
                amount = 0
            }
        }

        item.taxAmount = amount * (tax / 100)
        item.paymentAmount = amount - (amount * (tax / 100) )

        return item
    }

    columnTaxAmountChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["taxAmount"] = value;
        this.dataChanged(data);
    };

    columnPaymentAmountChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["paymentAmount"] = value;
        this.dataChanged(data);
    };

    getShowHideValueForTablePopup(tableColumnPopupType) {
        var item = AppManager.getTableColumnOptions(this.props.data.tableColumnPopup, tableColumnPopupType)
        if(item === undefined || item  === null) {
            return false
        }
        else {
            return item.isSelected
        }
    }

}
